import React , { useEffect ,useState} from "react";
import '../Assets/Css/product.css'
import { Container, Row, Col,  Button, Card ,Modal } from 'react-bootstrap';
import { FaArrowRight} from 'react-icons/fa';
import {
  FaShoppingCart,
  FaIndustry,
  FaFileSignature,
  FaGavel,
  FaHandshake,
  FaBalanceScale,
  FaBalanceScaleRight,
  FaFileContract,
  FaUsersCog,
  FaTruckLoading,
  FaShip,
  FaShieldAlt,
  FaMoneyBillWave,
  FaLightbulb,
  FaBoxes,
  FaGlobe,
  FaPiggyBank,
  FaCogs,
  FaExchangeAlt,
} from 'react-icons/fa';


import productbanner from '../Assets/Images/productbanner.avif';




import  prod1 from '../Assets/Images/HydratedLimePowder.jpg'
import  prod2 from "../Assets/Images/QuicklimeIndustrialGrade.jpg"
import  prod3 from "../Assets/Images/IndustrialGradeHydrochloricacid.jpg"
import  prod4 from "../Assets/Images/Technicalgradeurea.jpg"
import  prod5 from "../Assets/Images/ElectricalandGoodsElectronic .jpg"
import  prod6 from "../Assets/Images/SoilandFertilizers.jpg"
import  prod7 from "../Assets/Images/Inorganicchemicals.jpg"
import  prod8 from "../Assets/Images/organicchemicals.jpg"
import  prod9 from "../Assets/Images/Clothesandcosmetics.jpg"
import  prod10 from "../Assets/Images/CustomizeStationary.jpg"

import prod12 from "../Assets/Images/HydratedLimePowder1.avif"

import prod21 from "../Assets/Images/Quicklime.avif"

import  prodsub31 from "../Assets/Images/IndustrialGradeHydrochloricacidd.jpg"

import  prodsub41 from "../Assets/Images/Technicalgradeureaforindustrialuse only.jpg"

import  prodsub51 from "../Assets/Images/ElectricalandGoodsElectronic1.jpg"
import  prodsub52 from "../Assets/Images/ElectricalandGoodsElectronics2.jpg"

import prodst1  from "../Assets/Images/CustomizeStationary2.jpg"
import prodst2  from "../Assets/Images/CustomizeStationary3.jpg"

import service1 from "../Assets/Images/serviceweoffer.jpg"
import service2 from "../Assets/Images/serviceweoffer1.jpg"
import service3 from "../Assets/Images/serviceweoffer2.jpg"

import { IoIosArrowDroprightCircle } from "react-icons/io";

import { Helmet } from 'react-helmet';

export default function ProductPage() {

  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleShow = (product) => {
    setSelectedProduct(product);
    setSelectedImage(product.image); // Set the first image as the selected one
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };



  const products = [
    {
      title: "Industrial Grade Hydrated Lime Powder, 70 to 90%",
      brand: "SIDDHI INTERNATIONAL",
      description: "Industrial Grade Hydrated Lime Powder (70% to 90%)\nHydrated Lime / Calcium Hydroxide (traditionally called slaked lime) is an inorganic compound with the chemical formula Ca(OH)2. \nHydrated Lime Powder, commonly known as slaked lime, is a fine, dry powder manufactured by treating quicklime with water. It is used in a variety of industrial applications such as water treatment, soil stabilization, construction, and chemical processing.",
      image: prod1,
      additionalImages: [prod1,prod12],
      

    },
    {
      title: "Quicklime Industrial Grade 70 to 90%",
      description: "Quicklime is a white, caustic, alkaline crystalline solid produced by heating limestone in a kiln. It is highly reactive with water and used extensively in metallurgy, environmental, and chemical industries.",
      image: prod2,
      additionalImages: [prod2,prod21],
    },
    {
      title: "Industrial Grade (HCL) Hydrochloric acid 30-32%",
      description: "Hydrochloric acid is a clear, colorless solution with a strong pungent odor, widely used in chemical processing, pH regulation, and cleaning applications. Industrial grade HCl is suitable for manufacturing and treatment processes.",
      image: prod3,
      additionalImages: [prod3, prodsub31],
    },
    {
      title: "Technical grade urea 46% for industrial use only",
      description: "Technical grade urea is a high-nitrogen compound primarily used in industrial applications like resin manufacturing, de-icing agents, and as a component in certain adhesives",
      image: prod4,
      additionalImages: [prod4, prodsub41],
    },
    {
      title: "Electrical and Goods Electronic",
      description: "We export a wide range of electrical and electronic goods, from consumer electronics to industrial electrical components. All products meet international safety and quality standards",
      image: prod5,
      additionalImages: [prod5, prodsub51, prodsub52],
    },
    {
      title: "Soil and Fertilizers",
      description: "FERTILIZERS – Natural Verses Synthetic\nWe supply a wide variety of soil conditioners and fertilizers to support sustainable agriculture",
      image: prod6,
      additionalImages: [prod6],
    },
    {
      title: "Inorganic chemicals",
      description: "A diverse range of inorganic chemicals used in industrial, laboratory, and agricultural applications.",
      image: prod7,
      additionalImages: [prod7],
    },
    {
      title: "Organic Chemicals",
      description: "A comprehensive supply of high-purity organic chemicals for pharmaceutical, agricultural, and industrial use.",
      image: prod8,
      additionalImages: [prod8],
    },
    {
      title: "Clothes and cosmetics",
      description: "We trade in quality garments and cosmetics that meet global fashion and skincare standards.",
      image: prod9,
      additionalImages: [prod9],
    },
    {
      title: "Customize Stationary as per clients requirements",
      description: "We provide customized stationery solutions including notebooks, letterheads, business cards, and more tailored to client needs.",
      image: prod10,
      additionalImages: [prod10,prodst1,prodst2],
    },
  ];
  

  

  const services = [
    {
      title: 'B2B, B2C, and C2C',
      description: 'E-commerce encompasses transactions between businesses, businesses and consumers, and consumers themselves.',
      icon: <FaShoppingCart />,
    },
    {
      title: 'Legal and licensing services',
      description: 'Legal and licensing services involve obtaining necessary permits and complying with regulations to operate a business or engage in specific activities legally.',
      icon: <FaBalanceScale />,
    },
    {
      title: 'Industrial Licensing',
      description: 'Industrial Licensing',
      icon: <FaIndustry />,
    },
    {
      title: 'Business Registration & Licenses',
      description: 'Business Registration & Licenses',
      icon: <FaFileSignature />,
    },
    {
      title: 'Legal Representation',
      description: 'Legal Representation',
      icon: <FaGavel />,
    },
    {
      title: 'Contract Review and Negotiation',
      description: 'Contract Review and Negotiation',
      icon: <FaHandshake />,
    },
    {
      title: 'Importance of Legal and Licensing Services',
      description: 'Importance of Legal and Licensing Services',
      icon: <FaBalanceScaleRight />,
    },
    {
      title: 'Legal Compliance',
      description: 'Legal Compliance',
      icon: <FaFileContract />,
    },
    {
      title: 'Labour law services',
      description: 'Labour law services',
      icon: <FaUsersCog />,
    },
    {
      title: 'Customs Clearance',
      description: 'This involves managing the paperwork and procedures required to legally move goods into or out of a country.',
      icon: <FaTruckLoading />,
    },
    {
      title: 'Freight Forwarding',
      description: 'This includes arranging the transportation of goods by sea, air, or land, often involving the use of logistics companies.',
      icon: <FaShip />,
    },
    {
      title: 'Insurance',
      description: 'Protecting goods during transit and handling any potential losses or damage.',
      icon: <FaShieldAlt />,
    },
    {
      title: 'Financial Services',
      description: 'Providing solutions for international payments, currency exchange, and financing for import or export transactions.',
      icon: <FaMoneyBillWave />,
    },
    {
      title: 'Consulting Services',
      description: 'Offering guidance and support to businesses navigating the complexities of international trade, including finding suppliers, identifying markets, and understanding regulations.',
      icon: <FaLightbulb />,
    },
    {
      title: 'Examples of Import-Export',
      description: 'Examples of Import-Export.',
      icon: <FaBoxes />,
    },
    {
      title: 'The Importance of Export-Import Services',
      description: 'Facilitates International Trade:\nBy providing a range of services, export-import service providers help businesses navigate the complexities of international trade, enabling them to engage in global markets more effectively.',
      icon: <FaGlobe />,
    },
    {
      title: 'Reduces Costs',
      description: 'By streamlining processes and offering competitive rates, these services can help businesses reduce the overall cost of international trade.',
      icon: <FaPiggyBank />,
    },
    {
      title: 'Enhances Efficiency',
      description: 'Export-import services help businesses optimize their supply chains and improve the efficiency of their international operations.',
      icon: <FaCogs />,
    },
    {
      title: 'Trusted Partner in International and Local Trade',
      description: 'Trusted Partner in International and Local Trade.',
      icon: <FaHandshake />,
    },
    {
      title: 'EXPORT IMPORT AND LOCAL TRADE',
      description: '(ALL GOODS AND SERVICES EXCEPT MOTOR VEHICLES AND FOOD.) "ACIDS, CHEMICALS, SOLVENTS, INDUSTRIAL CHEMICALS. VARIOUS CHEMICAL COMPOUNDS. ORGANIC AND INORGANIC CHEMICALS. ELECTRONICS AND ELECTRICALS GOODS. AGRICULTURE PRODUCTS. ECOMMERCE TRADING ETC." LEGAL AND LICENSING SERVICES.',
      icon: <FaExchangeAlt />,
    },
    {
      title: 'Commission-Based Global Sourcing',
      description: 'We provide excellent and reliable services on a commission basis to source foreign markets for your manufactured products and the foreign products as per your requirements.',
      icon: <FaHandshake />,
    },
  ];
  
  

  
  


  return (
    <>
    
<div className="mainnav min-vh-100 bg-light">
     
<Helmet>
        <title>Complete Solutions for Global Trade & Industrial Needs | M/s. SIDDHI INTERNATIONAL</title>
        <meta
          name="description"
          content="Explore M/s. SIDDHI INTERNATIONAL – your trusted partner in global trade, certified chemicals, legal & licensing services, export-import, and more. Over 20 years of industry expertise."
        />
        <meta
          name="keywords"
          content="Global Trade, Export Import, Legal Services, Industrial Licensing, Chemicals, B2B E-commerce, Freight Forwarding, Customs Clearance, Financial Services, SIDDHI INTERNATIONAL, Technical grade urea, Hydrochloric acid, Hydrated Lime, Quicklime, Organic Chemicals, Inorganic Chemicals, Electronics, Stationery"
        />
        <meta name="author" content="M/s. SIDDHI INTERNATIONAL" />
        <meta property="og:title" content="Complete Solutions for Global Trade & Industrial Needs" />
        <meta
          property="og:description"
          content="Trusted experts in trading, manufacturing, licensing, and cross-border business support. Serving clients with certified products and reliable services."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://siddhinternational.com" />
        <meta property="og:image" content="https://siddhinternational.com/seo-image.jpg" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://siddhinternational.com" />
      </Helmet>
    

<div className="about-banner position-relative text-white">
  <img
    src={productbanner}
    alt="About Banner"
    className="aboutbanner-image "
  />
 
  <div className="container d-flex justify-content-center align-items-center h-100">
    <div className="row w-100 justify-content-center">
      <div className="col-12 col-md-6 px-3">
        <div className="maindesc">

      <h2  className="fw-bold">Complete Solutions for Global Trade & Industrial Needs</h2>
      <p>From certified chemicals to legal, licensing & export-import services — we power your business with trust and expertise.</p>
      </div>
      </div>
    </div>
  </div>
</div>

      <Container className="mb-4 py-4">
    <Row className="text-center mb-2">
      <Col>
        <h3  className="Mainhead">Our Products </h3>
        <p className="fw-medium text-muted">
          Explore our diversified portfolio in trading, manufacturing, licensing & more:
        </p>
      </Col>
    </Row>

    {/* Products Section */}
 


<Row className="mb-2">
        <Col md={12}>
          <Card className="border-0 bg-transparent">
            <Card.Body>
              <Row className="g-3 justify-content-center">
                {products.map((product, index) => (
                  <Col md={2} sm={4} xs={6} className="viewformob" key={index}>
                    <Card className="product-card glass-effect text-center h-100 border-0">
                      <div className="product-image-wrapper">
                        <img
                          src={product.image}
                          alt={product.title}
                          className="product-image"
                        />
                      </div>
                      <Card.Body>
                        <Card.Title className="fw-semibold h-50 product-title">
                          {product.title}
                        </Card.Title>
                        <Button
                          className="fs-5 "
                          style={{ background: "none", color: "#29AAE1",border:'none',padding:'4px' }}
                          onClick={() => handleShow(product)}
                        >
                          View <IoIosArrowDroprightCircle />
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

  </Container>

  
  {/* Modal */}
  {/* <Modal show={showModal} centered onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={4}>
             
              <div className="text-center p-2">
              <img
                src={selectedImage}
                alt={selectedProduct?.title}
                className="img-fluid "
                style={{ height:'200px',width:'300px', objectFit: "fill",borderRadius:'8px' }}
              />
              </div>
              <div className="d-flex mt-2">
                
                {selectedProduct?.additionalImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Thumbnail ${index}`}
                    className="img-thumbnail"
                    style={{ width: "80px",height:'80px', cursor: "pointer", marginRight: "5px" }}
                    onClick={() => handleImageClick(image)}
                  />
                ))}
              </div>
            </Col>
            <Col md={8}>
            <h5 className="text-info text-center">{selectedProduct?.title}</h5>
              <p>{selectedProduct?.description}</p>
            </Col>
          </Row>
        </Modal.Body>
      </Modal> */}

<Modal show={showModal} centered onHide={handleClose} size="lg" dialogClassName="premium-modal">
  <Modal.Header closeButton className="border-0 pb-0">
  </Modal.Header>
  <Modal.Body>
    <Row>
      <Col md={5} className="text-center">
        <div className="main-image-wrapper">
          <img
            src={selectedImage}
            alt={selectedProduct?.title}
            className="main-product-image"
          />
        </div>
        <div className="thumbnail-wrapper mt-3 d-flex justify-content-center flex-wrap">
          {selectedProduct?.additionalImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Thumbnail ${index}`}
              className={`thumb-image ${selectedImage === image ? "active" : ""}`}
              onClick={() => handleImageClick(image)}
            />
          ))}
        </div>
      </Col>
      <Col md={7} className="d-flex flex-column ">
        <h4 className="text-center text-info fw-bold mb-3">{selectedProduct?.title}</h4>
        <p className="text-muted">{selectedProduct?.description}</p>
      </Col>
    </Row>
  </Modal.Body>
</Modal>

  
  
  
  
  
  
  <div className="bg-body-secondary p-4">
<Container className='mb-4 ' >
        <Row className="text-center">
          <Col>
            
            <Row>
              
            <Col lg={6}>
  <h3 className="Mainhead">Services We Offer</h3>
  <p style={{ textAlign: 'justify' }}>
    At <b style={{ color: '#29AAE1' }}>M/s. SIDDHI INTERNATIONAL</b>, we provide a wide range of services to help businesses across various sectors. We specialize in E-commerce (B2B, B2C, C2C), Legal & Licensing Services, Industrial Licensing, and Business Registration. Our <b>Consulting Services</b> guide international trade, while <b>Customs Clearance</b> and <b>Freight Forwarding</b> streamline logistics. Additionally, we offer <b>Insurance</b> to protect goods, <b>Financial Services</b> for cross-border transactions, and solutions to reduce trade costs and optimize supply chains. With 20+ years of experience, we are a trusted partner in export-import and local trade, offering reliable services on a commission basis.
  </p>
</Col>

            <Col lg={6}>
  <Row className="justify-content-center">
    <Col lg={10} className="mb-3">
      <img src={service1} alt="" style={{ width: '100%', height: '200px',borderRadius:'8px' }} />
    </Col>
  </Row>
  <Row className="justify-content-center g-3"> 
  <Col lg={5}>
      <img src={service3} alt="" 
      style={{ width: '100%', height: '200px',borderRadius:'8px' }} />
    </Col>
    <Col lg={5}>
      <img src={service2} alt="" 
      style={{ width: '100%', height: '200px',borderRadius:'8px' }} />
    </Col>
    
  </Row>
</Col>
            </Row>
          </Col>
        </Row>
        </Container>
</div>
    
  <div  className="mb-4 mt-3 servicesback">
  <Container>
        <h3 className="Mainhead mb-4">Services </h3>
        <Row className="gx-5 gy-4">
          {services.map((service, index) => (
            <Col key={index} md={4}>
              <div className="service-line h-100 d-flex align-items-start gap-3">
                
                <div className="icon-box">{service.icon}</div>
                <div>
                  <h6 className="mb-1 fw-semibold text-dark">{service.title}</h6>
                  <p className="mb-0 text-muted small">{service.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
       
      </Container>
    </div>

      </div>


    </>
  )
}
